import title from './title';
import style from './style';
import focus from './focus';
import enterNumber from './enter-number';
import backgroundColor from './background-color';

/**
 * 定义vue指令
 */
export default {
  install(Vue) {
    Vue.directive('title', title);
    Vue.directive('style', style);
    Vue.directive('focus', focus);
    Vue.directive('enter-number', enterNumber);
    Vue.directive('background-color', backgroundColor);
  },
};
